import { useAppSelector } from '../../../app/hooks'
import { geoToPixel } from '../../../shared/utils/geoToPixel.utils'
import { BoundingBox } from '../../../shared/types'
import { POIPointsProps } from './types'

const usePOIPoints = (props: POIPointsProps) => {
  const { mapBounds, imageWidth, imageHeight } = props
  const nearbyPOI = useAppSelector((state) => state.poi.nearby.data)

  if (!nearbyPOI || nearbyPOI.length === 0) {
    return { points: [] }
  }

  const points = nearbyPOI
    .filter((poi) => {
      // verify lat/long exist
      const hasValidCoords =
        typeof poi?.lat === 'number' && typeof poi?.long === 'number'
      if (!hasValidCoords) {
        console.warn('Missing lat/long for:', poi)
      }
      return hasValidCoords
    })
    .map((poi) => {
      const { lat, long } = poi
      const { x, y } = geoToPixel(
        lat as number,
        long as number,
        mapBounds,
        imageWidth,
        imageHeight
      )
      return {
        id: poi.id,
        name: poi.name,
        key: poi.key,
        x,
        y,
      }
    })

  return { points }
}

export default usePOIPoints
